module.exports = __webpack_public_path__ + "static/media/bg_home.0c4ea682.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_home.png
// module id = 1143
// module chunks = 0